module.exports = __webpack_public_path__ + "644093b41161e6e23b4d0e250cac87c3.svg";